import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { isNull } from 'lodash';
import { Grid } from '@material-ui/core';
import ACCIDENT_PARTICIPANT_TYPES from '../../../containers/CascoCompensationContainer/options';
import MainRadio from '../../MUI/MainRadio';

const ChangeParticipant = ({ participantIs, handleChange, applicantToVictim }) => {
  const getIsChecked = useCallback(
    (value) => (participantIs ? value === participantIs : value === ACCIDENT_PARTICIPANT_TYPES[0].value),
    [participantIs],
  );

  return (
    <Grid container spacing={2} style={{ marginBottom: 16 }}>
      {ACCIDENT_PARTICIPANT_TYPES.map(({ value, label }) => (value === 'applicant' && (isNull(applicantToVictim) && applicantToVictim) !== 'other' ? (
        ''
      ) : (
        <Grid key={label} item>
          <MainRadio
            name="participantIs"
            labelKey={label}
            value={value}
            checked={getIsChecked(value)}
            onChange={({ e }) => handleChange(e.target.value)}
          />
        </Grid>
      )))}
    </Grid>
  );
};

ChangeParticipant.propTypes = {
  handleChange: PropTypes.func.isRequired,
  applicantToVictim: PropTypes.string,
  participantIs: PropTypes.string.isRequired,
};

ChangeParticipant.defaultProps = {
  applicantToVictim: null,
};

export default ChangeParticipant;
